<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <!-- 统计卡片 -->
                    <a-row :gutter="[16, 16]" class="stat-row">
                        <a-col :xs="12" :sm="8" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-blue">
                                        <FileTextOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">日志总数</div>
                                        <div class="stat-value stat-value-sm">{{ log_Conf.total }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-green">
                                        <ArrowUpOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">收入日志</div>
                                        <div class="stat-value stat-value-sm">{{ incomeCount }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-orange">
                                        <ArrowDownOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">支出日志</div>
                                        <div class="stat-value stat-value-sm">{{ expenseCount }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                    </a-row>

                    <!-- 日志列表卡片 -->
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">操作日志记录</span>
                                <a-tag color="blue">{{ log_Conf.total }} 条</a-tag>
                            </div>
                        </template>

                        <a-table class="log-table-pc" :data-source="log_data" :pagination="false" row-key="id"
                            :scroll="{ x: 800 }" size="small" :loading="log_loading" bordered :columns="logColumns">
                            <template #bodyCell="{ column, record }">
                                <!-- 日志类型 -->
                                <template v-if="column.key === 'log_act'">
                                    <a-tag :color="getLogTagColor(record.log_act)">
                                        {{ getLogAct(record.log_act) }}
                                    </a-tag>
                                </template>

                                <!-- 交易后余额 -->
                                <template v-else-if="column.key === 'afterMoney'">
                                    <span
                                        :class="['money-text', record.afterMoney != undefined ? 'money-after' : 'money-none']">
                                        {{ record.afterMoney != undefined ? record.afterMoney : '无' }}
                                    </span>
                                </template>

                                <!-- 交易前余额 -->
                                <template v-else-if="column.key === 'beforeMoney'">
                                    <span
                                        :class="['money-text', record.beforeMoney != undefined ? 'money-before' : 'money-none']">
                                        {{ record.beforeMoney != undefined ? record.beforeMoney : '无' }}
                                    </span>
                                </template>

                                <!-- 操作金额 -->
                                <template v-else-if="column.key === 'operationMoney'">
                                    <span :class="['money-text',
                                        record.operationMoney != undefined
                                            ? (record.log_act == 2 ? 'money-expense' : 'money-income')
                                            : 'money-none'
                                    ]">
                                        {{ record.operationMoney != undefined
                                            ? (record.log_act == 2 || record.log_act == 4
                                                ? '-' + record.operationMoney + '元'
                                                : '+' + record.operationMoney + '元')
                                        : '无' }}
                                    </span>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="log-card-list" v-if="log_data && log_data.length > 0">
                            <a-card v-for="record in log_data" :key="record.id" class="log-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">
                                        <span class="mobile-id">#{{ record.id }}</span>
                                        <a-tag :color="getLogTagColor(record.log_act)">{{ getLogAct(record.log_act)
                                            }}</a-tag>
                                    </div>
                                    <span class="mobile-time">{{ record.add_time }}</span>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">内容</span>
                                        <span class="mobile-value">{{ record.log_desc }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">操作金额</span>
                                        <span :class="['money-text',
                                            record.operationMoney != undefined
                                                ? (record.log_act == 2 ? 'money-expense' : 'money-income')
                                                : 'money-none'
                                        ]">
                                            {{ record.operationMoney != undefined
                                                ? (record.log_act == 2 || record.log_act == 4
                                                    ? '-' + record.operationMoney + '元'
                                                    : '+' + record.operationMoney + '元')
                                            : '无' }}
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">交易前</span>
                                        <span
                                            :class="['money-text', record.beforeMoney != undefined ? 'money-before' : 'money-none']">
                                            {{ record.beforeMoney != undefined ? record.beforeMoney : '无' }}
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">交易后</span>
                                        <span
                                            :class="['money-text', record.afterMoney != undefined ? 'money-after' : 'money-none']">
                                            {{ record.afterMoney != undefined ? record.afterMoney : '无' }}
                                        </span>
                                    </div>
                                </div>
                            </a-card>
                        </div>

                        <!-- 空状态（手机端） -->
                        <a-empty v-if="(!log_data || log_data.length === 0) && !log_loading" class="log-mobile-empty"
                            description="暂无日志数据" />

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="log_Conf.currentPage" v-model:page-size="log_Conf.pageSize"
                                :page-size-options="[10, 25, 50]" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条记录`" :total="log_Conf.total"
                                @change="pageChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script lang="ts" setup>
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, computed } from 'vue';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import axios from 'axios';
import { message } from 'ant-design-vue';
import {
    FileTextOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
} from '@ant-design/icons-vue';

const baseURL = process.env.VUE_APP_API_BASE_URL;

// 日志分页配置
const log_Conf = ref({
    currentPage: 1,
    pageSize: 10,
    total: 0,
});

// 日志数据
const log_data = ref<any[]>([]);

// 加载状态
const log_loading = ref(false);

// 日志类型转文字
const getLogAct = (act: number): string => {
    switch (act) {
        case 1:
            return '收入';
        case 2:
            return '支出';
        case 3:
            return '登录';
        case 4:
            return '其他';
        case 5:
            return '作者收入';
        default:
            return '未知';
    }
};

// 日志类型对应 a-tag 颜色
const getLogTagColor = (act: number): string => {
    switch (act) {
        case 1:
            return 'green';
        case 2:
            return 'red';
        case 3:
            return 'blue';
        case 4:
            return 'default';
        case 5:
            return 'cyan';
        default:
            return 'default';
    }
};

// 统计收入日志数量
const incomeCount = computed(() => {
    return log_data.value.filter(item => item.log_act === 1 || item.log_act === 5).length;
});

// 统计支出日志数量
const expenseCount = computed(() => {
    return log_data.value.filter(item => item.log_act === 2).length;
});

// 表格列配置
const logColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60, align: 'center' as const },
    { title: '日志类型', dataIndex: 'log_act', key: 'log_act', width: 100, align: 'center' as const },
    { title: '内容', dataIndex: 'log_desc', key: 'log_desc', ellipsis: true },
    { title: '交易后余额', dataIndex: 'afterMoney', key: 'afterMoney', width: 120, align: 'right' as const },
    { title: '交易前余额', dataIndex: 'beforeMoney', key: 'beforeMoney', width: 120, align: 'right' as const },
    { title: '操作金额', dataIndex: 'operationMoney', key: 'operationMoney', width: 120, align: 'right' as const },
    { title: '时间', dataIndex: 'add_time', key: 'add_time', width: 170, align: 'center' as const },
];

// 获取用户日志
const getUserLog = () => {
    openLoading();
    log_loading.value = true;
    const data = new FormData();
    data.append('page', String(log_Conf.value.currentPage));
    data.append('pageSize', String(log_Conf.value.pageSize));
    const headers = {
        token: localStorage.getItem('token'),
    };
    axios
        .post(baseURL + '/userApi/getUserLog', data, { timeout: 5000, headers })
        .then(res => {
            if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
                return;
            }
            if (res.data.code == 200) {
                log_data.value = res.data.data;
                log_Conf.value.total = res.data.total;
                return;
            } else {
                message.error(res.data.msg);
            }
        })
        .catch(err => {
            message.error(err.message || '请求失败');
        })
        .finally(() => {
            fullscreenLoading.close();
            log_loading.value = false;
        });
};

// 分页变化
const pageChange = (page: number, pageSize: number) => {
    log_Conf.value.currentPage = page;
    log_Conf.value.pageSize = pageSize;
    getUserLog();
};

onMounted(() => {
    getUserLog();
});
</script>

<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Stat Cards ===== */
.stat-row {
    margin-bottom: 12px;
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }

    :deep(.ant-card-body) {
        padding: 16px 20px;
    }
}

.stat-inner {
    display: flex;
    align-items: center;
    gap: 14px;
}

.stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;

    &.stat-icon-blue {
        background: linear-gradient(135deg, #e6f4ff, #bae0ff);
        color: #1677ff;
    }

    &.stat-icon-green {
        background: linear-gradient(135deg, #f6ffed, #d9f7be);
        color: #52c41a;
    }

    &.stat-icon-orange {
        background: linear-gradient(135deg, #fff7e6, #ffd591);
        color: #fa8c16;
    }
}

.stat-info {
    flex: 1;
    min-width: 0;
}

.stat-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 2px;
}

.stat-value {
    font-size: 22px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    line-height: 1.2;

    &.stat-value-sm {
        font-size: 18px;
    }
}

/* ===== Money Text Colors ===== */
.money-text {
    font-weight: 600;
    font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;

    &.money-income {
        color: #059669;
    }

    &.money-expense {
        color: #dc2626;
    }

    &.money-before {
        color: #d97706;
    }

    &.money-after {
        color: #2563eb;
    }

    &.money-none {
        color: #a0a5ad;
        font-weight: 400;
    }
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0 16px 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== Table Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
}

/* ===== Mobile Card List (hidden on PC) ===== */
.log-card-list,
.log-mobile-empty {
    display: none;
}

.log-card-list {
    gap: 12px;

    .log-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        min-width: 0;
    }

    .mobile-id {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
    }

    .mobile-time {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
        flex-shrink: 0;
        margin-left: 8px;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 60px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

    .log-table-pc,
    .table-pagination {
        display: none !important;
    }

    .log-card-list,
    .log-mobile-empty {
        display: flex !important;
    }

    .log-card-list {
        flex-direction: column;
    }

    /* Layout */
    .ant-layout-content {
        padding: 12px !important;
    }

    /* Stat Cards */
    .stat-row {
        margin-bottom: 8px;
    }

    .stat-card :deep(.ant-card-body) {
        padding: 12px 14px;
    }

    .stat-inner {
        gap: 10px;
    }

    .stat-icon {
        width: 36px;
        height: 36px;
        font-size: 16px;
        border-radius: 8px;
    }

    .stat-label {
        font-size: 11px;
    }

    .stat-value {
        font-size: 18px;

        &.stat-value-sm {
            font-size: 15px;
        }
    }

    /* Table Card */
    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 0 12px 12px;
    }

    .card-title-row {
        gap: 8px;
    }

    .card-title-text {
        font-size: 13px;
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }

    .stat-card :deep(.ant-card-body) {
        padding: 10px 12px;
    }

    .stat-icon {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }

    .stat-value {
        font-size: 16px;

        &.stat-value-sm {
            font-size: 14px;
        }
    }
}
</style>
